

jQuery(function($) {
    // Article Results
   if(window.location.href.indexOf("type=article") > -1) {
          $j('.njohn_article_search_bar').css('display','block');
          $j('#centerColumn').addClass('njohn_article_thumbs');
          $j('.njohn_product_grid_column').removeClass('njohn_product_sold_out');
   }
});